import { useCore } from '@danone-global/internal/react/core'
import React from 'react'

import amLogo from './assets/logo-aptaclub.png'
import amDachLogo from './assets/logo-aptaclub-dach.png'
import cgLogo from './assets/logo-cow-gate.png'
import cgHappyLogo from './assets/logo-cow-gate-happy-kids.png'
import ganmaiLogo from './assets/logo-ganmai.png'
import medicalLogo from './assets/logo-medical.png'
import milupaLogo from './assets/logo-milupa.png'
import nutriciaLogo from './assets/logo-nutricia.png'
import nlLogo from './assets/nutricia-logo-education.png'


export interface Props {
  className?: string
}

export const BrandLogo: React.FC<Props> = ({ className }) => {
  const { config } = useCore()

  const logoSrc = React.useMemo(() => {
    switch (config.siteName) {
      case 'uk-am':
      case 'hk-am':
        return amLogo

      case 'uk-cg':
        return cgLogo

      case 'hk-cg':
        return cgHappyLogo

      case 'hk-ganmai':
        return ganmaiLogo

      case 'dach-am':
        return amDachLogo

      case 'dach-milupa':
        return milupaLogo

      case 'dach-nutricia':
        return nutriciaLogo

      case 'uk-medical-uk':
      case 'uk-medical-ie':
        return medicalLogo

      case 'nl-nutricia':
        return nlLogo  

      default:
        return null
    }
  }, [])

  if (!logoSrc) {
    return null
  }

  return (
    <div className={className}>
      <img alt="brand logo" src={logoSrc} />
    </div>
  )
}

export default BrandLogo
